export default __webpack_public_path__ + "static/mag-860b1300f44a05682b2f63421e7724c0.png";